__turbopack_context__.v({
  "icon": "Tab-module__IYopwq__icon",
  "tab": "Tab-module__IYopwq__tab",
  "tabActive": "Tab-module__IYopwq__tabActive",
});
